import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { FundingSourceItem } from 'fragments/fundingSource';
import { fundingSourceActions, systemActions } from 'store';
import { FindLoad, PermissionList, RolePermission } from 'utils';
import { Loader } from 'components';

const ACTION_TYPE = 'GET_FUNDING_SOURCE_BY_ID';
export const FundingSourceSingle = () => {
    const dispatch = useDispatch();
    const params = useParams();
    const loader = FindLoad(ACTION_TYPE);

    useEffect(() => {
        if (RolePermission([PermissionList.FS_READ?.code, PermissionList.FS_CREATE?.code])) {
            dispatch(fundingSourceActions.getFundingSourceById(params.id));
            dispatch(fundingSourceActions.getFundingSourceClients(params.id));
        }
        dispatch(systemActions.canUseIntegration());
    }, []);

    if (loader?.length) {
        return <Loader />;
    }

    return <FundingSourceItem />;
};
